import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { MEMBERSHIP_COLORS } from "@/features/pathpick/features/membership/constants";
import { PATHPICK_LANDING_PATH } from "@/features/pathpick/features/landing/constants";

// "패스픽이 처음이신가요?" 안내 배너 — 안내 보기 클릭 시 패스픽 랜딩페이지로 이동
function PathPickMembershipIntroBanner() {
  const { t } = useI18nHelper();
  // 로케일 접두사(/ko)를 붙여 이동한다 — 접두사 없는 경로로 navigate 하면 루트 로더가
  // push 리다이렉트를 걸어 히스토리에 칸이 하나 더 쌓이고 뒤로가기가 한 번에 먹지 않는다.
  const { navigate } = useRouterHelper();

  return (
    // "패스픽 안내 보기" + chevron이 ~130px 비축소라 좁은 폭에서 텍스트를 밀어낸다.
    <Flex
      justifyContent={"space-between"}
      flexDirection={{ base: "column", md: "row" }}
      alignItems={{ base: "flex-start", md: "center" }}
      gap={"16px"}
      padding={"15px 18px"}
      borderRadius={"8px"}
      border={`1px solid ${MEMBERSHIP_COLORS.blueBorder}`}
      background={MEMBERSHIP_COLORS.blueBg}
    >
      <Flex gap={"12px"} alignItems={"center"} minWidth={0}>
        <Flex
          boxSize={"34px"}
          alignItems={"center"}
          justifyContent={"center"}
          borderRadius={"8px"}
          background={MEMBERSHIP_COLORS.blue}
          flexShrink={0}
        >
          <CustomIcon
            src={"info-circle"}
            width={20}
            height={20}
            color={"#FFFFFF"}
          />
        </Flex>
        <Flex flexDirection={"column"} gap={"2px"} minWidth={0}>
          <Text
            textStyle={"body-md-bold"}
            fontSize={"15px"}
            color={MEMBERSHIP_COLORS.textStrong}
          >
            {t("membership:intro.title")}
          </Text>
          <Text
            textStyle={"body-sm-regular"}
            color={MEMBERSHIP_COLORS.textMuted}
          >
            {t("membership:intro.description")}
          </Text>
        </Flex>
      </Flex>
      <AppButton
        variant={"white"}
        onClick={() => navigate(PATHPICK_LANDING_PATH)}
        chakraProps={{
          flexShrink: 0,
          height: "40px",
          borderRadius: "10px",
          border: `1px solid ${MEMBERSHIP_COLORS.blueBorder}`,
          background: MEMBERSHIP_COLORS.cardBg,
        }}
      >
        <Flex gap={"4px"} alignItems={"center"}>
          <Text
            textStyle={"body-sm-bold"}
            fontWeight={800}
            color={MEMBERSHIP_COLORS.blueDeep}
          >
            {t("membership:intro.cta")}
          </Text>
          <CustomIcon
            src={"chevron-right"}
            width={16}
            height={16}
            color={MEMBERSHIP_COLORS.blueDeep}
          />
        </Flex>
      </AppButton>
    </Flex>
  );
}

export default PathPickMembershipIntroBanner;
